

















/**
 * 一个通用小 title
 */
import {Vue, Component, Prop} from 'vue-property-decorator';

@Component
export default class UTitle extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  }) public icon!: boolean;

  @Prop({
    type: String,
    required: true,
  }) public title!: boolean;

  @Prop({
    type: String,
    default: '',
  }) public titleLink!: boolean;

  @Prop({
    type: String,
    default: '',
  }) public moreLink!: boolean;
}
